import { render, staticRenderFns } from "./attribute-icon.vue?vue&type=template&id=185fc92d&scoped=true&"
import script from "./attribute-icon.vue?vue&type=script&lang=js&"
export * from "./attribute-icon.vue?vue&type=script&lang=js&"
import style0 from "./attribute-icon.vue?vue&type=style&index=0&id=185fc92d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185fc92d",
  null
  
)

export default component.exports